import { takeEvery, put, select, call } from "redux-saga/effects";
import {
  getDocumentsList,
  setDocumentsList,
  downloadDocument,
  documentListError
} from "../actions/orderDocuments";
import { getDocumentsListRequest } from "../../api/orderDocuments/getDocumentsListRequest";
import { downloadDocumentRequest } from "../../api/orderDocuments/downloadDocumentRequest";
import { message } from "antd";

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getDocumentsListSaga(action) {
  const activeProfileId = yield select(getActiveProfileId);
  try {
    const orderId = action.payload;
    const response = yield call(
      getDocumentsListRequest,
      orderId,
      activeProfileId
    );
    if (response.status === 200) {
      yield put(setDocumentsList(response.data));
    }
  } catch (e) {
    const { errors } = e && e.response && e.response.data;
    const errorMessage =
      e && e.response && e.response.data && e.response.data.message;
    message.error(errorMessage);
    yield put(documentListError({ message: errorMessage, errors }));
  }
}

function* downloadDocumentSaga(action) {
  const { payload } = action;
  const { orderId, key, orderNumber } = payload;
  try {
    const response = yield call(downloadDocumentRequest, orderId, key);
    if (response.status === 200) {
      if ((Array.isArray(key) && key.length < 2) || !Array.isArray(key)) {
        const url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/pdf"
          })
        );
        const documentKey = key || key[0];
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        document.body.appendChild(link);
        // clist - список детей
        // fplist - cписок продуктов питания
        // alist - список сопровождающих
        // gn - уведомление гибдд
        // сс - договор фрахтования
        // wo - заказ-наряд
        // gi - идентификатор гибдд
        // receipt - квитанция
        // rp - маршрут перевозки
        // waybill - путевой лист
        // di - список водителей
        // bill - cчет с/без ндс
        // ra - акт об оказании услуг
        // hwi - список медработников
        // plist - список пассажиров
        // arrland - список посадки высадки
        // kidsnight - cписок мест размещения для проживания детей в ночное время
        // workphys - список работник и физ.лиц
        link.setAttribute(
          "download",
          `Заказ-${orderNumber}-${
            documentKey === "clist"
              ? "список детей"
              : key === "fplist"
              ? "cписок продуктов питания"
              : key === "alist"
              ? "список сопровождающих"
              : key === "gn"
              ? "уведомление гибдд"
              : key === "сс"
              ? "договор фрахтования"
              : key === "wo"
              ? "заказ-наряд"
              : key === "gi"
              ? "идентификатор гибдд"
              : key === "receipt"
              ? "квитанция"
              : key === "rp"
              ? "маршрут перевозки"
              : key === "waybill"
              ? "путевой лист"
              : key === "di"
              ? "список водителей"
              : key === "bill"
              ? "cчет с/без ндс"
              : key === "ra"
              ? "акт об оказании услуг"
              : key === "hwi"
              ? "список медработников"
              : key === "plist"
              ? "список пассажиров"
              : ""
          }.pdf`
        );
        link.click();
        link.remove();
      } else {
        const url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/zip"
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", `Заказ-${orderNumber}.zip`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    }
  } catch (e) {
    if (e && e.response && e.response.data) {
      const { errors } = e && e.response && e.response.data;
      const errorMessage =
        e && e.response && e.response.data && e.response.data.message;
      message.error(errorMessage);
      yield put(documentListError({ message: errorMessage, errors }));
    }
  }
}

export function* orderDocumentsListWatcher() {
  yield takeEvery(getDocumentsList.toString(), getDocumentsListSaga);
  yield takeEvery(downloadDocument.toString(), downloadDocumentSaga);
}
